import * as loginService from "./loginService";

let logOutTimer = new Date().getTime();

export function updateToCurrentTime() {
    logOutTimer = new Date().getTime();
}

export function signOutTimer() {
    setInterval(() => {
        const currentTime = new Date().getTime();
        if (currentTime - logOutTimer > 3600000) {
            // 1 hour
            loginService.signOut().then(() => {
                window.location.href = "/";
            });
        }
    }, 3000);
}
